import { render, staticRenderFns } from "./editProductPriceRule.vue?vue&type=template&id=6555978d"
import script from "./editProductPriceRule.vue?vue&type=script&lang=js"
export * from "./editProductPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports